import { createSelector } from 'reselect'

export const getResult = state => state.search.result

export const isResultExists = createSelector(
  [ getResult ],
  (result = {}) => {
    return Object.keys(result).reduce((flag, key) => {
      if (result[key] && result[key].length && !flag) flag = true
      return flag
    }, false)
  }
)



// WEBPACK FOOTER //
// ./src/selectors/search.js